/**
 * A sessão entre abas (F-S5, T-35).
 *
 * `localStorage` é compartilhado entre as abas da mesma origem, mas a
 * **memória** de cada aba não é: `getAccessToken` só relê o storage quando a
 * memória está vazia, e `setAccessToken(null)` zera a memória apenas da aba
 * que clicou em "Sair". Uma aba esquecida continuava autenticada.
 *
 * O evento `storage` dispara nas OUTRAS abas quando uma chave muda. Este
 * módulo é a decisão — pura, para o `node --test` — de quando esse evento quer
 * dizer "a sessão acabou": só quando os **dois** tokens sumiram, porque o
 * access some sozinho, de passagem, durante o bootstrap e a renovação da
 * outra aba, e cair nesse momento seria deslogar quem acabou de renovar.
 */

export interface StorageChange {
  /** `null` é `localStorage.clear()`. */
  key: string | null;
  /** `null` é remoção; um valor é escrita ou rotação. */
  newValue: string | null;
}

export interface StoredSession {
  access: string | null;
  refresh: string | null;
}

export function sessaoAcabouEmOutraAba(
  change: StorageChange,
  restante: StoredSession,
  chavesDaSessao: readonly string[],
): boolean {
  if (change.key === null) return true;
  if (!chavesDaSessao.includes(change.key)) return false;
  if (change.newValue !== null) return false;
  return restante.access === null && restante.refresh === null;
}
